import {useRef} from 'react';
import {VERIFICATION_METHODS} from '@guestapp/sdk';
import {useMutateReservation} from 'hooks';
import {useReservation} from 'context/reservation';
import {useRemoteIVFlow} from 'hooks/iv/ivRemoteFlow';
import {useVerificationSettings} from 'hooks/iv/useVerificationSettings';
import {ContactsVerificationComplete} from './ContactsVerificationComplete';
import {VerificationData} from './types';

const ContactsVerificationView = () => {
  const {housing} = useReservation();
  const {isEmailEnabled, isPhoneEnabled, isNeedVerification} = useVerificationSettings(
    housing?.id,
  );
  const {goNextAfterContactVerification} = useRemoteIVFlow(isNeedVerification);
  const {mutate: mutateReservation} = useMutateReservation();

  const emailRef = useRef<VerificationData>({
    type: VERIFICATION_METHODS.email,
    data: '',
    verified: false,
  });
  const phoneRef = useRef<VerificationData>({
    type: VERIFICATION_METHODS.phone,
    data: '',
    verified: false,
  });

  const getIsAllVerified = () => {
    if (isEmailEnabled && isPhoneEnabled)
      return emailRef.current.verified && phoneRef.current.verified;
    if (isEmailEnabled) return emailRef.current.verified;
    if (isPhoneEnabled) return phoneRef.current.verified;
    return false;
  };

  const handleVerificationComplete = (data: VerificationData) => {
    if (data.type === VERIFICATION_METHODS.email)
      emailRef.current = {
        type: VERIFICATION_METHODS.email,
        data: data.data,
        verified: data.verified,
      };
    if (data.type === VERIFICATION_METHODS.phone)
      phoneRef.current = {
        type: VERIFICATION_METHODS.phone,
        data: data.data,
        verified: data.verified,
      };

    if (getIsAllVerified()) {
      mutateReservation({
        payload: {
          default_invite_email:
            emailRef.current.verified && emailRef.current.data
              ? emailRef.current.data
              : undefined,
          default_phone_number:
            phoneRef.current.verified && phoneRef.current.data
              ? phoneRef.current.data
              : undefined,
        },
      });

      goNextAfterContactVerification();
    }
  };

  return (
    <ContactsVerificationComplete
      enableEmail={isEmailEnabled}
      enablePhone={isPhoneEnabled}
      onVerificationComplete={handleVerificationComplete}
    />
  );
};

export {ContactsVerificationView};
